import dynamic from "next/dynamic";

import { Box, Heading } from "@cruk/cruk-react-components";

import { type PageType } from "@fwa/src/types";

const EditablePageTitleForm = dynamic(
  () => import("@fwa/src/components/EditablePageTitleForm"),
);

import styles from "./styles.module.css";

export const PageTitle = ({
  page,
  canEdit,
  isTeam = false,
  updateAndMutatePage,
}: {
  page: PageType;
  canEdit: boolean;
  isTeam?: boolean;
  updateAndMutatePage: (
    data: Partial<PageType>,
    refresh?: boolean,
  ) => Promise<void | PageType>;
}) => {
  if (!page) return null;

  return (
    <span
      className={styles["title-wrapper"]}
      data-component={`${isTeam ? "team" : "page"}-title`}
    >
      <Box
        backgroundColor="background-light"
        margin="none"
        style={
          {
            padding: "var(--spacing-s, 1.5rem)",
            display: "block",

            "@media (minWidth: 992px)": {
              display: "inline-block",
              marginBottom: 0,
            },
          } as React.CSSProperties
        }
      >
        {canEdit ? (
          <EditablePageTitleForm
            page={page}
            isTeam={isTeam}
            updateAndMutatePage={updateAndMutatePage}
          />
        ) : (
          <Heading
            h1
            margin="none"
            paddingRight="s"
            style={{
              width: "fit-content",
              display: "block",
            }}
            overflowWrap="break-word"
          >
            {page.title}
          </Heading>
        )}
      </Box>
    </span>
  );
};

export default PageTitle;
